import { config } from 'api';
import { UNKNOWN_ERROR } from 'utils/errors';
import { setErrorMessage } from 'apps/notifications/actions/notifications';

const GET_ORDERS_URL = `${config.apiBasePath}/slotsub/orders`;
const createBuildOrderUrl = (orderNumber) => `${config.apiBasePath}/slotsub/orders/${orderNumber}/build`;

export const OR_REQUEST_ORDERS = 'OR_REQUEST_ORDERS';
export const OR_RECEIVE_ORDERS = 'OR_RECEIVE_ORDERS';
export const OR_RECEIVE_ORDERS_ERROR = 'OR_RECEIVE_ORDERS_ERROR';
export const OR_TOGGLE_FUTURE_ORDERS_SECTION = 'OR_TOGGLE_FUTURE_ORDERS_SECTION';

export const OR_BUILD_ORDER_REQUEST = 'OR_BUILD_ORDER_REQUEST';
export const OR_BUILD_ORDER_SUCCESS = 'OR_BUILD_ORDER_SUCCESS';
export const OR_BUILD_ORDER_ERROR = 'OR_BUILD_ORDER_ERROR';
export const OR_BUILD_ORDER_PAYMENT_FAILED = 'OR_BUILD_ORDER_PAYMENT_FAILED';

export const BUILD_ORDER_ERROR_MESSAGE = 'Ups... an error occured while trying to create the order. Please try again.';

const PAYMENT_FAILED = 'PAYMENT_FAILED';

export function requestOrders() {
  return {
    type: OR_REQUEST_ORDERS,
  };
}

export function receiveOrders(data) {
  return {
    type: OR_RECEIVE_ORDERS,
    data,
  };
}

export function receiveOrdersError({ error }) {
  return {
    type: OR_RECEIVE_ORDERS_ERROR,
    error,
  };
}

export function getOrders() {
  return (dispatch, getState, { network }) => {
    dispatch(requestOrders());
    return network.get(GET_ORDERS_URL)
      .then((data) => {
        dispatch(receiveOrders(data));
      })
      .catch(err => {
        dispatch(receiveOrdersError(err.data || UNKNOWN_ERROR));
      });
  };
}

export function requestBuildOrder(orderNumber) {
  return {
    type: OR_BUILD_ORDER_REQUEST,
    orderNumber,
  };
}

export function buildOrderSuccess(orderNumber) {
  return {
    type: OR_BUILD_ORDER_SUCCESS,
    orderNumber,
  };
}

export function buildOrderError({ error }, orderNumber) {
  return {
    type: OR_BUILD_ORDER_ERROR,
    error,
    orderNumber,
  };
}

export function buildOrderPaymentFailed() {
  return {
    type: OR_BUILD_ORDER_PAYMENT_FAILED,
  };
}

export function buildOrder(orderNumber) {
  return (dispatch, getState, { network }) => {
    dispatch(requestBuildOrder(orderNumber));
    return network.post(createBuildOrderUrl(orderNumber))
      .then((data) => {
        dispatch(buildOrderSuccess(orderNumber));
        if (data.orderBuildStatus === PAYMENT_FAILED) {
          dispatch(buildOrderPaymentFailed());
        }
        dispatch(getOrders());
      })
      .catch(err => {
        dispatch(buildOrderError(err.data || UNKNOWN_ERROR, orderNumber));
        dispatch(setErrorMessage(BUILD_ORDER_ERROR_MESSAGE));
      });
  };
}

export function toggleFutureOrdersSection() {
  return {
    type: OR_TOGGLE_FUTURE_ORDERS_SECTION,
  };
}
